import * as React from "react";
import { QuickJournalThemeSwitcher } from "../QuickJournal/View/Controls/QuickJournalThemeSwitcher";
import type { QuickJournalThemeSelectionName } from "../QuickJournal/View/QuickJournalTheme";

export function QuickJournalOverlay({
    className,
    visible,
}: {
    className: string;
    visible: boolean;
}) {
    return (
        <div
            className={className}
            style={{
                opacity: visible ? 1 : 0,
                transition: visible
                    ? "opacity 350ms ease"
                    : "opacity 200ms ease",
            }}
        />
    );
}

export function ThemeSwitcherContainer({
    visible,
    activeThemeName,
    onThemeNameChange,
}: {
    visible: boolean;
    activeThemeName: QuickJournalThemeSelectionName;
    onThemeNameChange: (name: QuickJournalThemeSelectionName) => void;
}) {
    return (
        <div
            style={{
                position: "fixed",
                top: "12.5vh",
                left: "calc(env(safe-area-inset-left, 0px) + 4px)",
                transform: "translateY(0)",
                zIndex: 20003,
                opacity: visible ? 1 : 0,
                pointerEvents: visible ? "auto" : "none",
                transition: visible
                    ? "opacity 350ms ease"
                    : "opacity 200ms ease",
            }}
        >
            <QuickJournalThemeSwitcher
                activeThemeName={activeThemeName}
                onThemeNameChange={onThemeNameChange}
            />
        </div>
    );
}
